import { render, staticRenderFns } from "./NumericQuestion.vue?vue&type=template&id=ddfe35be&scoped=true&"
import script from "./NumericQuestion.vue?vue&type=script&lang=js&"
export * from "./NumericQuestion.vue?vue&type=script&lang=js&"
import style0 from "./NumericQuestion.vue?vue&type=style&index=0&id=ddfe35be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfe35be",
  null
  
)

/* custom blocks */
import block0 from "./NumericQuestion.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./NumericQuestion.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
